import { ReactNode } from 'react';
import clsx from 'clsx';

import styles from './page-header.module.scss';

export type PageHeaderProps = {
  title: string;
  children: ReactNode;
};

export function PageHeader({ title, children }: PageHeaderProps) {
  return (
    <div className={clsx(styles['root'])}>
      <div className={clsx('page-header', styles['title'])}>{title}</div>
      {children}
    </div>
  );
}
